/**
 * Alkalmazotti idézet komponens modul
 * @author Erik Banhalmi 2017.06.27.
 */
import angular from 'angular';
import { UniversalQoutationDisplayerComponent } from './universal-qoutation-displayer.component';
import QoutationService from './../../qoutation-service/qoutation-service.module';

import 'slick-carousel/slick/slick.min';
import 'angular-slick-carousel';

const MODULE_NAME = 'universalQoutationDisplayer';

export default angular.module(MODULE_NAME, ['slickCarousel', QoutationService]).component('universalQoutationDisplayer', UniversalQoutationDisplayerComponent)
	.name;


